import React from "react"
// @ts-ignore
import FieldRenderEditableInlineTextarea from "../inline-editable/textarea-editable-inline"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";

export default function FieldText_FormElementView(props:FieldFormElementViewProps) {
    const disabled  = _.get(props.options, 'disabled', false) || _.get(props, 'disabled', false)
    const value     = props.model[props.field.fieldId]

    return <FieldRenderEditableInlineTextarea viewClasses   = {Classes("ui5-txt-default ui5-field-form-editable min-h-36 p-l-10 p-r-10 p-t-7 p-b-7", props.className)}
                                              editClasses   = {Classes("ui5-txt-default ui5-field-form-editable min-h-36 p-l-10 p-r-10 p-t-7 p-b-7", props.className)}
                                              field         = {props.field}
                                              rows          = {props.rows}
                                              value         = {value}
                                              disabled      = {disabled}
                                              onChange      = {props.onChange}/>
}